<template>
  <px-lateral-dialog v-model="dialog" width="800" content-class="rounded-card">
    <template v-slot:activator="{ on }">
      <v-btn depressed
             color="primary"
             :class="btnClass"
             :small="small"
             :block="block"
             v-on="on">
        Gerar pagamento
      </v-btn>
    </template>
    <template v-slot:title>
      Gerar pagamento
    </template>
    <template>
      <div>
        <v-list class="body-1" v-for="pacote in pacotes" :key="pacote.id">
          <v-list-item v-for="item in pacote.ofertas" :key="item.id">
            <v-list-item-avatar class="square-avatar">
              <px-oferta-foto height="40"
                              width="40"
                              :foto="item.oferta.foto"/>
            </v-list-item-avatar>
            <v-list-item-content>
              {{ item.tituloProduto }}
            </v-list-item-content>
            <v-list-item-content>
              <b>{{ item.total | currency }}</b>
              <div class="body-2">
                {{ item.quantidade }} {{ item.unidadeMedida.descricao }}
              </div>
            </v-list-item-content>
            <v-list-item-content>
              <px-input-money
                dense
                class="rounded-tag-small"
                ref="valorAdicional"
                label="Valor adicional"
                v-model="item.valorAdicional"/>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-row class="text--primary title">
          <v-col cols="12" class="text-right pr-8">
            Total:
            <b>{{ total | currency }}</b>
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-slot:actions>
      <div class="px-3 pb-3 full-width text-right">
        <v-btn depressed class="rounded-tag-small normal-btn-text" @click="close">
          Fechar
        </v-btn>
        <v-btn depressed
               color="primary"
               class="ml-3 rounded-tag-small normal-btn-text"
               :loading="loading"
               @click="onClickEnviar">
          Gerar pagamento
        </v-btn>
      </div>
    </template>
  </px-lateral-dialog>
</template>

<script>
import { flatten } from 'lodash';
import currency from 'currency.js';
import CompraService from '../compras-service';

export default {
  props: {
    compra: {
      type: Object,
      required: true,
    },
    btnClass: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: true,
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      pacotes: [],
    };
  },
  computed: {
    total() {
      const ofertas = flatten(this.pacotes.map((pacote) => (pacote.ofertas)));
      const valorAdicional = ofertas
        .map((item) => (item.valorAdicional))
        .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
      return currency(this.compra.total)
        .add(valorAdicional || 0)
        .value;
    },
  },
  methods: {
    onClickEnviar() {
      this.save();
    },
    save() {
      this.loading = true;
      CompraService.aprovarValorFinal(this.compra.id, this.buildPayload())
        .then(() => {
          this.close();
          this.$emit('movimentar');
          this.$toast('O pagamento está sendo emitido para o cliente', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildPayload() {
      return {
        pacotes: this.pacotes.map((pacote) => ({
          ...pacote,
          ofertas: pacote.ofertas.map((oferta) => ({
            id: oferta.id,
            valorAdicional: oferta.valorAdicional,
          })),
        })),
      };
    },
    buildItems() {
      this.pacotes = this.compra.pacotes
        .map((pacote) => ({
          id: pacote.id,
          ofertas: pacote.ofertas.map((oferta) => ({
            ...oferta,
            valorAdicional: null,
          })),
        }));
    },
    close() {
      this.dialog = false;
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.buildItems();
    },
  },
};
</script>
